export const scrollToHomeSection = (targetId) => {
  if (targetId === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const targetSection = document.getElementById(targetId);
  if (targetSection) {
    targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  if (targetId === 'contact') {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  }
};

export const getHomeSectionTarget = (location) => {
  if (location.pathname !== '/') return null;
  if (location.state?.scrollTo) return location.state.scrollTo;
  if (location.hash) return location.hash.slice(1);
  return null;
};
